import React, { useState, useEffect } from "react";
import "./App.css";
import { HashRouter } from "react-router-dom";
import Navigation from "./navigation.js";
import { useSelector } from "react-redux";
import Widgets from "../src/widgets";
import "./i18n";
import { useTranslation } from "react-i18next";

const LoadingIndicator = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  return isLoading ? <Widgets.LoadingContainer /> : null;
};

function App() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  return (
    <div className="App">
      <HashRouter basename="/">
        {!isOnline && <div className="no-internet-bar">{t("youAreOffline")}</div>}
        <div className="loading-app-container">
          <LoadingIndicator />
        </div>
        <Navigation />
        <Widgets.ToastContainer />
      </HashRouter>
    </div>
  );
}

export default App;
